// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/eye-off.js';

import { paths } from '../generated/eye-off';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('eye-off', Original, paths);
